module.exports = __webpack_public_path__ + "static/img/anxunCompang.d5abb3c4.png";